import { render, staticRenderFns } from "./system_config.vue?vue&type=template&id=056fb679&scoped=true"
import script from "./system_config.vue?vue&type=script&lang=js"
export * from "./system_config.vue?vue&type=script&lang=js"
import style0 from "./system_config.vue?vue&type=style&index=0&id=056fb679&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fb679",
  null
  
)

export default component.exports